<div class="oi-main-dshd">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="oi-comen-heading header-heading-fx">
          <div class="row">
            <div class="col-md-5">
              <h2>Get Answers</h2>
            </div>
            <div class="col-md-4">
              <div class="oi-hist-switch get-histry">
                <div class="oi-hs-text1">History</div>
                <label class="switch">
                  <input type="checkbox"  [(ngModel)]="showHistory" (click)="toggleHistory()">
                  <span class="slider round"></span>
                </label>
                
                </div>
            </div>

            <div class="col-md-3">
              <div class="oi-select-fld1">
                <p-dropdown [options]="availableCollections" [(ngModel)]="selectedCollection" optionLabel="collectionName" optionValue="collectionName" placeholder="Select a Collection" (onChange)="changeCollection($event)"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12">
      <div class="get-new-answerchat d-flex align-items-start flex-column">
        <div class="get-ans-detail-mn" #scrollMe>
          <div class="go-complete-btn"><a  routerLink="/saved-answer">Go Complete History <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M5 12h.5m3 0h1.5m3 0h6" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg></a></div>
          <div class="get-ans-history" *ngIf="showHistory"> 
            <ng-container *ngIf="loader else showcontent">
              <div class="imgloader" *ngIf="loader">
                <img src="../../assets/img/loader.gif">
              </div>
            </ng-container>
            <ng-template #showcontent>
              <div class="row" *ngIf="saved_answers else noresult">
                <div class="col-md-12">
                  <div class="oi-save-ans-bx-main chunk-most-parent" *ngFor="let savedanswer of saved_answers.slice(0,5).reverse(); let i = index" data-answer-type="saved-answers" [attr.data-question-index]="i">
                    <!-- <div class="oi-save-ans-top"><div class="oi-save-ans-switch"><label class="switch"><input type="checkbox" checked><span class="slider round"></span></label></div><div class="oi-sav-answer-star"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><div class="oi-save-ans-date">28 Feb 2024 | 02:30 PM</div></div> -->
                    <div class="oi-certified-icon"  *ngIf="savedanswer.answer_approved==1" >
                      <img src="../../assets/img/badge.png">
                    </div>
                    <div class="oi-qns-ans-box box "  [ngClass]="{'aibt-qns-bx': savedanswer.answered_by?.toLowerCase() === 'bot','bot-qns-bx': savedanswer.answered_by === 'Canned'}">
                      <div class="qns-nn1 hovernewcopy">
                      <div class="oi-sav-qns " [innerHTML]="savedanswer.sanitizedQuestion"> </div>

                      <div class="copybtnnew" >
                        <button class="btn btn-primary"  title="Copy" (click)="copyQuestionandAns(savedanswer.question)">
                          <img src="../assets/img/copy.svg">
                        </button></div>
                      </div>

 
                    <div class="qns-nn1 hovernewcopy1">
                      <div class="oi-sav-ans" *ngIf="!savedanswer.isBotMenu" [innerHTML]="savedanswer.sanitizedAnswer"></div>
                      <div class="copybtnnew1" (click)="copyQuestionandAns(savedanswer.answer)">
                        <button class="btn btn-primary"  title="Copy" (click)="copyQuestionandAns(savedanswer.answer)">
                        <img src="../assets/img/copy.svg">
                      </button></div>
                       </div>
                     
                     
                      <div class="oi-sav-ans" *ngIf="savedanswer.isBotMenu">
                        <p>{{ savedanswer.botMenu[0]?.text }}</p>
                        <div class="oi-gt-chat-tag">
                          <button 
                            class="btn btn-tag "
                            *ngFor="let button of savedanswer.botMenu[0]?.buttons"
                            (click)="handleBotMenuSelection(button.title,savedanswer.canned_question_id)">
                            {{ button.title }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="oi-getai-btn" *ngIf="savedanswer.answered_by?.toLowerCase() === 'bot'"><img src="../assets/img/brain-icon.svg"> Ai Generated</div>
                    <div class="oi-genrate-tag-btn g-top" *ngIf="savedanswer.answered_by =='Canned'"><img src="../assets/img/power-icon.svg">Cached Response</div> 
                    <div  class="oi-exclamation-tag-btn g-top ng-star-inserted" *ngIf="savedanswer.answered_by== 'Canned'">Similarity {{ (savedanswer.confidence * 100) | number:'1.0-0' }}% </div>

                  </div>
                </div>
              </div>
              <ng-template #noresult>
                <div class="oi-no-resultfound">
                  <img src="../../assets/img/no-result.png">
                  <h3>Sorry! No result found :</h3>
                  <p>We're sorry what you were looking for. Please try another way</p>
                </div>
              </ng-template>
            </ng-template>
          </div>
          <div class="imgloader" *ngIf="timer">
            <img class="" src="../../assets/img/loader.gif">
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="oi-get-answer-api oi-vh-height">
             
                <div class="oi-qns-ans-main-scroll" >
                  <div class="get-ans-bx11" *ngIf="answersArray?.length > 0 ">
                    <ng-container *ngFor="let data of answersArray; let i = index">
                      <div class="answer-block chunk-most-parent" data-answer-type="answers-array" [attr.data-question-index]="i">
                      <div class="qna-box mt-3 p-3 border rounded"  [ngClass]="{'aibt-qns-bx': data.answered_by?.toLowerCase() === 'bot','bot-qns-bx': data.answered_by === 'Canned'}">
                      <div class="oi-get-qns-ans-mn1 d-flex justify-content-start">
                        <!-- <div class="oi-get-usr">
                          <span>{{this.firstInitial ? this.firstInitial : 'U'}}</span>
                        </div> -->
                        <div class="oi-get-text-n1 oi-bx-hover1 d-flex flex-column oi-new-width" style="position: relative;">
                          <div class="oi-git-bld">You</div>
                          <p>{{data.question}}</p>
                           <div class="oi-get-msg-hvr-btn newalign1"> 
                            <button class="btn btn-primary"  title="Copy"  (click)="copyQuestionandAns(data.question)">
                              <img src="../assets/img/copy.svg">
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="oi-get-qns-ans-mn1 d-flex justify-content-start" >
                        <!-- <div class="oi-get-usr">
                          <div class="oi-gt-icon">
                          <img src="../../assets/img/logo-circle.svg">
                          </div>
                          
                        </div> -->

                        <!-- <div class="oi-gt-usr-new">
                          <button class="oi-gt-ans-img" ><img src="../../assets/img/logo-circle.svg"></button>
                        </div> -->

                        <div class="oi-get-text-n1 oi-bx-hover1 d-flex flex-column" style="position: relative;">
                          <div class="oi-get-msg-hvr-btn"> 
                            <button class="btn btn-primary"  title="Copy"  (click)="copyToClipboard(data.answer,data.questionId)">
                              <img src="../assets/img/copy.svg">
                              <span *ngIf="isCopied[data.questionId]" class="copied-message">Copied to clipboard!</span>
                            </button>
                          </div>
                          <div class="oi-git-bld">OneInsight</div>
                           <p *ngIf="!data.isBotMenu && !data.showTranslated" [innerHTML]="sanitizeMessage(data.answer)"></p>

                            <!-- Translated Answer -->
                            <p *ngIf="!data.isBotMenu && data.showTranslated" [innerHTML]="sanitizeMessage(data.translatedAnswer)"></p>

                            <!-- Bot Menu Buttons -->
                            <div *ngIf="data.isBotMenu">
                              <p>{{ data.botMenu[0]?.text }}</p>
                              <div class="oi-gt-chat-tag">
                                <button
                                  class="btn btn-tag active" [ngClass]="{'active': selectedBotMenuTitle === button.title}"
                                  *ngFor="let button of data.botMenu[0]?.buttons"
                                  (click)="handleBotMenuSelection(button.title,data.questionId)">
                                  {{ button.title }}
                                </button>
                              </div>
                            </div>

                        </div>
                      </div>
                     </div> 
                     <div  class="oi-getai-btn ng-star-inserted"  *ngIf="data.answered_by?.toLowerCase() === 'bot'"><img  src="../assets/img/brain-icon.svg"> Ai Generated</div>

                     <div class="oi-genrate-tag-btn g-top ng-star-inserted"  *ngIf="data.answered_by =='Canned'"><img  src="../assets/img/power-icon.svg">Cached Response</div>

                     <div  class="oi-exclamation-tag-btn g-top" *ngIf="data.answered_by== 'Canned'">Similarity {{ (data.confidence * 100) | number:'1.0-0' }}%  </div>
                     </div>
                    </ng-container>
                  </div>
                  <div class="get-ans-bx1">
                    <ng-container>
                      <div *ngIf="question != ''" class="oi-get-qns-ans-mn1 d-flex justify-content-start">
                        <!-- <div class="oi-get-usr">
                          <span>{{this.firstInitial ? this.firstInitial : 'U'}}</span>
                        </div> -->
                        <div class="oi-get-text-n1 d-flex flex-column">
                          <div class="oi-git-bld">You</div>
                          <p>{{question}}</p>
                        </div>
                      </div>
                      <div *ngIf="displayedData" class="oi-get-qns-ans-mn1 d-flex justify-content-start">
                        <div class="oi-get-usr oi-gt-icon">
                          <img src="../../assets/img/logo-circle.svg">
                        </div>
                        <div class="oi-get-text-n1 d-flex flex-column">
                          <div class="oi-git-bld">OneInsight</div>
                          <p *ngIf="!isBotMenu" [innerHTML]="sanitizeMessage(displayedData)"></p>
                            <div *ngIf="isBotMenu">
                              <p>{{ botMenu[0]?.text }}</p>
                              <div class="btn-group d-flex flex-wrap mt-2">
                                <button 
                                  class="btn btn-outline-primary m-1" [ngClass]="{'active': selectedBotMenuTitle === button.title}"
                                  *ngFor="let button of botMenu[0]?.buttons">
                                  {{ button.title }}
                                </button>
                              </div>
                            </div>  

                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="oi-no-resultfound" *ngIf="errorMessage">
                    <img src="../../assets/img/try-again.png">
                    <h3>Oops..!</h3>
                    <p>Something Went Wrong. Please try again later.</p>
                  </div>
                  <div class="oi-suggestion-mn" *ngIf="searchcontainer">
                    <div class="oi-sugg-inner" *ngIf="suggestions?.length > 0">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="oi-sugg-heading">
                            <h3>Trending Questions</h3>
                          </div>
                        </div>
                      </div>
                      <div class="row d-flex justify-content-evenly">
                        <div class="col-md-6" *ngFor="let suggestion of suggestions">
                          <div class="oi-sugg-box1 d-flex justify-content-between align-items-center" (click)="selectedpinitem(suggestion.question)">
                            <div class="oi-sugg-content">
                              <h4>{{suggestion.question}}</h4>
                            </div>
                            <div class="oi-sugg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="get-ans-chat-field mt-auto">
          <div class="oi-fixed-get">
            <div class="oi-header-search box d-flex justify-content-start align-items-end">
              <div class="oi-search-hd-main">
                <textarea id="chatgpt" (keydown.enter)="detectlanguage()" (input)="autoExpand($event)" [(ngModel)]="searchcollection" class="oi-genrate-field" name="chatgpt" rows="1" autocomplete="off">Please type your question

        </textarea>
                <!--<input type="text" class="form-control oi-search1"  (keyup.enter)="onEnterSearchText()"
 

      [(ngModel)]="searchcollection" id="fname" name="fname" placeholder="Please type your question"

       autocomplete="off" [disabled]="showtextbox"><div *ngIf="searchcontainer"  class="suggestions-container"><div *ngFor="let suggestion of suggestions" (click)="selectedpinitem(suggestion.question)">

          {{suggestion.question}}

        </div></div> -->
              </div>
              <div class="oi-head-serach-btn">
                <button type="button" class="search-button " [disabled]="showtextbox" (click)="detectlanguage()" [ngClass]="{'se-disable-btn':showtextbox}">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                    <path d="M6.5 12h14.5" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="oi-get-answer-mn">
              <h2>Please type your question to receive an answer!</h2>
            </div>
          </div>
        </div>

      </div>
      </div>
    </div>




   
   

   
  </div>
</div>

<p-dialog 
  header="Source Chunks" 
  [(visible)]="showChunkModal" 
  [modal]="true" 
  [dismissableMask]="true"
  [style]="{width: '30vw'}"
  [baseZIndex]="10000"
  [position]="'right'"
  class="chunk-oi">

  <div *ngFor="let chunk of selectedChunks" class="chunk-inner-bx1">
    <div class="chunk-mini-card"  [class.highlighted]="chunk.chunk_key.includes('[' + highlightedChunkId + ']')">
     <h1>{{ chunk.document_name }}</h1>
     <p [innerHTML]="sanitizeMessage(chunk.chunk_text)"></p>
     <div class="chunk-bottom-btn">
       <button type="button" class="btn chunk-outline-primary" (click)="navigateToDoc(chunk)">
                        <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" /><path d="M11 13l9 -9" /><path d="M15 4h5v5" /></svg> View Full Document
                    </button>
                    <button type="button" class="btn chunk-primary" (click)="copyChunkExcerpt(chunk.chunk_text)">
                        <svg   viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg> Copy Excerpt
                    </button>
     </div>
    </div>
  </div>

</p-dialog>
